import {SideReelFeature} from "./SideReelFeature";
import {gsap} from "gsap";
import {HOTBGameData, xBombItem} from "../../../../server/HOTBData";
import {HOTB} from "../../../../HOTB";
import {GameConfig} from "../../../../GameConfig";
import {GameSymbol, SymbolsList, SymbolStates} from "../../../../reels/GameSymbol";
import {ISymbol} from "../../../../../core/reel/IReelData";
import {GameSounds} from "../../../../sound/GameSounds";

export class XBombFeature extends SideReelFeature {
    constructor(rowId: number, whichSide: string, featureName: string) {
        super(rowId, whichSide, featureName);
    }

    public triggerBomb(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            gameData: HOTBGameData = HOTB.model.gameData,
            xBombList: xBombItem[] = gameData.xBombList;

        if (xBombList.length > 0) {
            const matchingBombOnList: xBombItem | undefined = xBombList.find((item: xBombItem) => item.indexOnSideReel === this.rowId && item.isLeftSideReel === (this.side === "left"));

            if (matchingBombOnList) {
                const reelBuffer: number = 5,
                    bombReelId: number = matchingBombOnList.toCoord.x,
                    bombSymId: number = matchingBombOnList.toCoord.y,
                    trailPosX: number = (54 + ((bombReelId + 1) * GameConfig.symbolWidth)) + reelBuffer,
                    trailPosY: number = 288 + (bombSymId * GameConfig.symbolHeight),
                    symToRemove: ISymbol = HOTB.reelArea.getSymbolAtPosition(bombReelId, bombSymId);

                tl.add([
                    this.playAnimation("4_triggerStart"),
                    (): void => {
                        HOTB.soundPlayer.playSideReelFeatureSounds(GameSounds.XBOMB_JUMP);
                    }
                ]);

                tl.to(this.position, {
                    motionPath: {
                        path: [
                            {
                                x: this.position.x,
                                y: this.position.y
                            }, {
                                x: (this.position.x + trailPosX) / 2,
                                y: this.position.y - 200
                            }, {
                                x: trailPosX,
                                y: trailPosY
                            }
                        ],
                        curviness: 1
                    },
                    duration: GameConfig.triggerDeadDuration
                });

                tl.add([
                    this.playAnimation("5_triggerEnd"),
                    (): void => {
                        HOTB.soundPlayer.playSideReelFeatureSounds(GameSounds.XBOMB_LAND);
                    },
                    gsap.to(symToRemove, {
                        alpha: 0,
                        duration: 0.2
                    })
                ]);

                tl.add((): void => {
                    symToRemove.isRemoved = true;
                    HOTB.reelArea.mainReelModels[bombReelId].reelView.removeSymbol(symToRemove);
                });

                tl.add((): void => {
                    HOTB.reelArea.mainReelModels[bombReelId].reelView.transformSymbol(bombReelId, bombSymId, SymbolsList.XBOMB);
                });

                tl.add((): void => {
                    const xBombSymbol: ISymbol = HOTB.reelArea.getSymbolAtPosition(bombReelId, bombSymId),
                        splitSize: number = gameData.symbolSizes[bombReelId][bombSymId];

                    (<GameSymbol>xBombSymbol).splitCount = (splitSize === 1) ? 0 : splitSize;
                    (<GameSymbol>xBombSymbol).getStateAnimation(SymbolStates.NORMAL);
                });
            } else {
                debugger;
                throw new Error("check for xBombList in server response");
            }
        }

        return tl;
    }

    private getItemByIndex(rowId: number): xBombItem | null {
        const gameData: HOTBGameData = HOTB.model.gameData,
            xBombList: xBombItem[] = gameData.xBombList,
            currBomb: xBombItem | undefined = xBombList.find(xBombItem => xBombItem.indexOnSideReel === rowId);

        return currBomb || null;
    }
}